import type { IconSvgObject } from './types';

const HotelBellIcon: IconSvgObject = [
  ["path", { d: "M2 20.5H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 14.5C4 10.0817 7.58172 6.5 12 6.5C16.4183 6.5 20 10.0817 20 14.5C20.8656 14.5 21.6043 15.1258 21.7466 15.9796L22 17H2L2.2534 15.9796C2.3957 15.1258 3.13442 14.5 4 14.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 6.5V3.5M12 3.5H9.5M12 3.5H14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19 5.5L18.5 6.5M21.5 8L20.5009 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M5 5.5L5.5 6.5M3.49913 8.5L2.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default HotelBellIcon;
